import { HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing } from '@genial/design-tokens';
import { EquityEntity } from '@genial/services';
import { Utils } from '@genial/utils';
import { Text } from 'native-base';
import React from 'react';

import { LoadingFooter } from './loading';

interface FooterProps extends EquityEntity {
  isLoading: boolean;
}

export const Footer: React.FC<FooterProps> = ({
  quote: { bidPrice, askPrice, closePrice },
  isLoading,
}) => {
  if (isLoading) {
    return <LoadingFooter />;
  }
  return (
    <VStack
      space={Spacing['inset.nano']}
      borderRadius={BoxRadius.sm}
      bg={Color.background}
      px={Spacing['inline.xxs']}
      py={Spacing['inline.xxxs']}
      alignItems="center">
      <HStack alignItems="center" justifyContent="space-between" w="full">
        <VStack space={Spacing['stack.quarck']}>
          <Text variant="regular" color={Color['neutral.darkest']}>
            Melhor Compra
          </Text>
          <Text variant="regular" color={Color['neutral.darkest']}>
            {Utils.Mask.Money(bidPrice)}
          </Text>
        </VStack>
        <VStack space={Spacing['stack.quarck']}>
          <Text variant="regular" color={Color['neutral.darkest']}>
            Melhor Venda
          </Text>
          <Text variant="regular" color={Color['neutral.darkest']}>
            {Utils.Mask.Money(askPrice)}
          </Text>
        </VStack>
        <VStack space={Spacing['stack.quarck']}>
          <Text variant="regular" color={Color['neutral.darkest']}>
            Fechamento
          </Text>
          <Text variant="regular" color={Color['neutral.darkest']}>
            {Utils.Mask.Money(closePrice)}
          </Text>
        </VStack>
      </HStack>
    </VStack>
  );
};
